// External Link Constants
import {
  THRONE_URL,
  CASH_APP_URL,
  APPLE_PAY_EMAIL,
  VENMO_URL,
  PAYPAL_URL,
  WISHLIST_URL,
  TWITTER_URL,
  LOYALFANS_URL,
  YOUPAY_URL,
  CompanyEmailAddress,
  ETSY_URL,
  DISCORD_URL,
  BLUESKY_URL,
  X_URL,
  CHATURBATE_URL,
  I_WANT_CLIPS_URL,
  FETLIFE_URL,
  MANY_VIDS_URL,
  CLIPS4SALE_URL,
} from '../../utils/constants/Constants';
// Icons
import {
  FaPaypal,
  FaTwitter,
  FaInstagram,
  FaSnapchat,
  FaAmazon,
  FaApple,
  FaTiktok,
  FaTelegramPlane,
  FaEtsy,
  FaVideo,
  FaCloud,
  FaDiscord,
} from 'react-icons/fa';
import { FaBluesky } from 'react-icons/fa6';

import { BsQuestionCircle } from 'react-icons/bs';
import { FaXTwitter } from 'react-icons/fa6';
import { SiVenmo, SiCashapp } from 'react-icons/si';
import { GiStoneThrone } from 'react-icons/gi';
import { MdPayments } from 'react-icons/md';
import { RiScales3Fill } from 'react-icons/ri';
import { MdOutlineEmail } from 'react-icons/md';
// Image icons
import ThroneIconPurple from '../../assets/images/icons/throne-icon-no-background-purple.png';
import ThroneIcon from '../../assets/images/icons/throne-icon-no-background.png';
import YoupayIcon from '../../assets/images/icons/youpay-icon-no-background.png';
import FetlifeIcon from '../../assets/images/icons/fetfile-icon-no-background.png';
import LoyalFansIcon from '../../assets/images/icons/loyalfans-icon-no-background.png';
import ManyVidsIcon from '../../assets/images/icons/manyvids-icon.png';
import C4SIcon from '../../assets/images/icons/clips-4-sale-logo-purple.png';

// MAIN LINKS (Links Page Buttons)
export const linkButtonArray = [
  // LoyalFans
  {
    text: 'LoyalFans',
    link: LOYALFANS_URL,
    icon: (
      <img
        src={LoyalFansIcon}
        alt='LoyalFans'
        className='w-6 lg:w-8 object-contain'
      />
    ),
  },
  // Cash App
  {
    text: 'Cash App',
    link: CASH_APP_URL,
    icon: <SiCashapp />,
  },
  // Throne
  {
    text: 'Throne Wishlist',
    link: THRONE_URL,
    icon: (
      <img
        src={ThroneIconPurple}
        alt='Throne'
        className='w-6 lg:w-8 object-contain'
      />
    ),
  },
    // IWantClips
  {
    text: 'IWantClips',
    link: I_WANT_CLIPS_URL,
    icon: <FaVideo />,
  },
  // ManyVids
  {
    text: 'ManyVids',
    link: MANY_VIDS_URL,
    icon: (
      <img
        src={ManyVidsIcon}
        alt='ManyVids'
        className='w-6 lg:w-8 object-contain'
      />
    ),
  },
    // Clips4Sale
  {
    text: 'Clips4Sale',
    link: CLIPS4SALE_URL,
    icon: (
      <img
        src={C4SIcon}
        alt='Clips4Sale'
        className='w-6 lg:w-8 object-contain'
      />
    ),
  },
  // Chaturbate
  {
    text: 'Chaturbate',
    link: CHATURBATE_URL,
    icon: <FaVideo />,
  },
  // FetLife
  {
    text: 'FetLife',
    link: FETLIFE_URL,
    icon: (
      <img
        src={FetlifeIcon}
        alt='FetLife'
        className='w-6 lg:w-8 object-contain'
      />
    ),
  },
  // X / Twitter
  {
    text: 'X / Twitter',
    link: X_URL || TWITTER_URL,
    icon: <FaXTwitter />,
  },
  // Bluesky
  {
    text: 'Bluesky',
    link: BLUESKY_URL,
    icon: <FaBluesky />,
  },
  // Discord
  {
    text: 'Discord',
    link: DISCORD_URL,
    icon: <FaDiscord />,
  },
];

export const payLinkButtonArray = [
  { text: 'Cash App', link: CASH_APP_URL, icon: <SiCashapp /> },
  {
    text: 'Throne',
    link: THRONE_URL,
    icon: (
      <>
        <img src={ThroneIcon} alt='' className='w-6 lg:w-8 -ml-[1px]' />
      </>
    ),
  },
  { text: 'Apple Pay', link: APPLE_PAY_EMAIL, icon: <FaApple /> },
  { text: 'Venmo', link: VENMO_URL, icon: <SiVenmo /> },
  { text: 'PayPal', link: PAYPAL_URL, icon: <FaPaypal /> },
  { text: 'Amazon', link: WISHLIST_URL, icon: <FaAmazon /> },
  { text: 'Etsy', link: ETSY_URL, icon: <FaEtsy /> },
  {
    text: 'Youpay',
    link: YOUPAY_URL,
    icon: (
      <>
        <img src={YoupayIcon} alt='' className='w-6 lg:w-8 -ml-[1px]' />
      </>
    ),
  },
];

export const smallSocialMediaPins = [
  {
    serviceName: 'Twitter',
    icon: <FaXTwitter />,
    url: TWITTER_URL,
    background: { background: '#1DA1F2' },
  },
  {
    serviceName: 'Email',
    icon: <MdOutlineEmail />,
    url: `mailto:${CompanyEmailAddress}`,
    background: { background: '#FFFC00' },
  },
  {
    serviceName: 'Cashapp',
    icon: <SiCashapp />,
    url: CASH_APP_URL,
    background: { background: '#000' },
  },
  {
    serviceName: 'Throne',
    icon: (
      <>
        <img src={ThroneIcon} alt='' className='w-6 lg:w-8 -ml-[1px]' />
      </>
    ),
    url: THRONE_URL,
    background: { background: '#25D366' },
  },
];

export const smallPayPins = [
  {
    serviceName: 'Cashapp',
    icon: <SiCashapp />,
    url: CASH_APP_URL,
    background: { background: '#000' },
  },
  {
    serviceName: 'Throne',
    icon: (
      <>
        <img src={ThroneIcon} alt='' className='w-8 lg:w-10 -ml-[1px]' />
      </>
    ),
    url: THRONE_URL,
    background: { background: '#25D366' },
  },
];
